'use client';

import { GordonValues } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface Props {
  values: GordonValues;
  onValuesChange: (field: keyof GordonValues, value: number) => void;
  translations: ToolsTranslations['gordon'];
}

export default function CalculatorInputs({ values, onValuesChange, translations }: Props) {
  const handleChange = (field: keyof GordonValues) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(/\s/g, '').replace(/,/g, '.');
    const value = Number(raw);
    onValuesChange(field, isNaN(value) ? 0 : value);
  };

  const inputClass = "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500";

  return (
    <div className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.dividendPerShare}</label>
        <input type="text" value={values.dividendPerShare} onChange={handleChange('dividendPerShare')} className={inputClass} placeholder="0" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.requiredReturnPercent}</label>
        <input type="text" value={values.requiredReturnPercent} onChange={handleChange('requiredReturnPercent')} className={inputClass} placeholder="0" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.growthPercent}</label>
        <input type="text" value={values.growthPercent} onChange={handleChange('growthPercent')} className={inputClass} placeholder="0" />
      </div>
    </div>
  );
}


